import React from "react";

const AddOfflinePayment = () => {
  return (
    <div>
      <div>Add Offline Payment</div>
    </div>
  );
};

export default AddOfflinePayment;
